<form name="quickQuoteForm" #qqForm="ngForm" class="page" [appScrollIntoView]="page">

  <div class="cube">
    <div class="questions">

      <ng-container *ngFor="let question of page.questions">
        <div *ngIf="question.visible" class="question">
          <div class="separator" *ngIf="question.type==='ImageSelect'"></div>
          <app-question [question]="question"
            [showHeader]="page.questions.length &gt; 1 || page.questions.length === 1 "></app-question>
        </div>
      </ng-container>

      <div class="summary__buttons" buttons>
        <ion-button (click)="back.emit($event)" *ngIf="showBackButton">
          <ion-icon name="chevron-back-outline"></ion-icon>
          Back
        </ion-button>
        <ion-button (click)="page.nextPage()" [disabled]="!qqForm.form.valid">
          Continue
          <ion-icon name="chevron-forward-outline"></ion-icon>
        </ion-button>
      </div>
    </div>

    <div class="line" *ngIf="!page.comment">
    </div>
    <div class="info" *ngIf="page.comment">
      <div>
        {{page.comment?.text}}
        <ion-button *ngIf="page.comment?.linkText"
          (click)="calculateNow(page.comment?.link)">{{page.comment?.linkText}}</ion-button>
      </div>
    </div>
  </div>

</form>